import script from "./CollapseContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapseContainer.vue?vue&type=script&setup=true&lang=js"

import "./CollapseContainer.vue?vue&type=style&index=0&id=1089747b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1089747b"]])

export default __exports__